import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  totalRows: 0,
};

const solicitacaoHistoricoSlice = createSlice({
  name: 'solicitacaoHistorico',
  initialState,
  reducers: {
    setHistorico(state, action) {
      state.data = action.payload.data;
      state.totalRows = action.payload.totalRows;
    },
    addHistorico(state, action) {
      state.data.unshift(action.payload);
      state.totalRows += 1;
    },
    clearHistorico(state) {
      state.data = [];
      state.totalRows = 0;
    }
  },
});

export const { addHistorico } = solicitacaoHistoricoSlice.actions;

export default solicitacaoHistoricoSlice.reducer;
